import React from 'react';

import './AssistantBanner.less';

type AssistantBannerProps = {
  icon: string;
  text: React.ReactNode;
  ctaLabel: string;
  onCtaClick: () => void;
  onBannerClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
};

const AssistantBanner = ({
  icon,
  text,
  ctaLabel,
  onCtaClick,
  onBannerClick,
  loading,
  disabled,
  className,
}: AssistantBannerProps) => {
  return (
    <div
      className={`assistant-banner${onBannerClick ? ' assistant-banner--clickable' : ''}${className ? ` ${className}` : ''}`}
      onClick={onBannerClick}
    >
      <span className="assistant-banner__info">
        <i className={icon} aria-hidden="true"></i>
        <span className="paragraph--s">{text}</span>
      </span>
      <button
        type="button"
        className="btn thule-btn-link btn-sm assistant-banner__cta"
        disabled={disabled || loading}
        aria-busy={loading}
        onClick={(e) => {
          e.stopPropagation();
          onCtaClick();
        }}
      >
        <span className="heading6">{ctaLabel}</span>
        <i className={loading ? 'le-icon-refresh-ccw spinner' : 'le-icon-arrow rot-180'} aria-hidden="true"></i>
      </button>
    </div>
  );
};

export default AssistantBanner;
